import sichero4 from "src/shared/assets/sichero/sichero4.png";
import sichero5 from "src/shared/assets/sichero/sichero5.png";
import sichero6 from "src/shared/assets/sichero/sichero6.png";
import sichero7 from "src/shared/assets/sichero/sichero7.png";
import sichero8 from "src/shared/assets/sichero/sichero8.png";
import sichero9 from "src/shared/assets/sichero/sichero9.png";
import sichero10 from "src/shared/assets/sichero/sichero10.png";
import sichero11 from "src/shared/assets/sichero/sichero11.png";

export const sicheroSections = [
  {
    image: sichero4,
    title: "SOS Function",
    text: "Experience peace of mind with SICHERO's Smart SOS feature — a single press calls a loved one or a nurse instantly. Plus, enjoy easy access to health analytics, user management, and customizable settings, all designed for seamless elderly care at home.",
  },
  {
    image: sichero5,
    title: "Fall Detection",
    text: "SICHERO ensures the safety of elderly individuals by detecting falls in real-time. It can accurately identify sudden movements and positions characteristic of a fall and sends an SOS to a nurse.",
  },
  {
    image: sichero6,
    title: "Dehydration Detection",
    text: "SICHERO is equipped with advanced object detection and activity algorithms that precisely monitor when the user consumes water. If it identifies a deviation from the user's typical water intake patterns, indicating lower consumption, it promptly notifies the caregivers of this concern. ",
  },
  {
    image: sichero7,
    title: "Activity Recognition",
    text: "SICHERO meticulously observes a range of user actions, such as sitting, lying down, remaining stationary, and walking. Should there be a noticeable deviation from the user’s typical activity patterns, indicating reduced activity, SICHERO promptly notifies caregivers of these potential concerns.",
  },
  {
    image: sichero8,
    title: "Automatic SOS Call",
    text: "Upon detection, SICHERO promptly alerts predefined emergency contacts or care services, ensuring that help is dispatched as quickly as possible.",
  },
  {
    image: sichero9,
    title: "Voice Command",
    text: "Our device, enhanced with voice command capabilities, offers robust security by verifying user identity through voice recognition. It intelligently discerns the user's language, interprets spoken statements, and executes tasks such as displaying today's weather forecast.",
  },
  {
    image: sichero10,
    title: "As AI Data Hub",
    text: "SICHERO is a mini-computer analysing all the user informatios to help the caregivers recognize anomalies in the behaviour of the elderly.",
  },
  {
    image: sichero11,
    title: "Safety Everywhere",
    text: "SICHERO can communicate with up to 3 external flexible moving cameras, ensuring safety and analytics quality wherever needed. You can place those cameras in the living room or in the kitchen, wherever you want.",
  },
];
